<template>
  <div class="d-flex justify-center">
    <div class="main-card mt-3">
      <!-- when loading -->
      <v-row v-if="loading" class="mx-3 my-1">
        <v-col cols="12" md="6" lg="6" v-for="n in 4" :key="n">
          <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
        </v-col>
      </v-row>
      <!-- when error -->
      <v-row v-if="!loading && errorMsg != ''" class="mx-3 my-1">
        <v-col cols="12">
          <v-alert type="error">{{ errorMsg }}</v-alert>
        </v-col>
      </v-row>
      <!-- when all ok -->
      <v-row v-if="!loading && errorMsg == ''" class="mx-3 my-1">
        <v-col
          cols="12"
          v-for="(reviews, day) in reviewsAIGroupedByDay"
          :key="day"
        >
          <p class="text-overline">{{ day }}</p>
          <v-col cols="12" md="6" lg="6" v-for="r in reviews" v-bind:key="r.id">
            <v-card
              color="white mt-0"
              class="mb-2 mx-auto mr-2"
              :class="$colorUtils.leftBorderColorForTier(r.Tier)"
              :to="`/review-status-ai?reviewId=${r.Id}`"
            >
              <v-card-text class="pb-2">
                <v-row>
                  <v-col cols="6" class="pt-1 pb-1">
                    <div
                      class="font-weight-bold float-left"
                      :class="$colorUtils.textColorForTier(r.Tier)"
                    >
                      {{ $consts.TIER_MAP.get(r.Tier).name }}
                    </div>
                  </v-col>
                  <v-col cols="6" class="pt-1 pb-1">
                    <div class="float-right">
                      {{ $utils.relativeTimeFromTs(r.UploadedTs) }}
                    </div>
                  </v-col>
                </v-row>
                <v-row class="pt-0 pb-0 mt-1 mb-0">
                  <v-col cols="12" class="pt-0 pb-0 mt-0 mb-0">
                    <p
                      class="text--disabled overline mb-0 pb-0 mt-0 pt-0"
                      style="font-size: 0.6rem !important"
                    >
                      ID: {{ r.Id }}
                    </p>
                  </v-col>
                </v-row>
                <v-row class="pt-0 pb-0 mt-0 mb-0">
                  <v-col cols="7" class="pt-1 pb-1">
                    <div
                      class="text-h6 text--primary text-truncate float-left"
                      style="max-width: 105%"
                    >
                      {{ r.ResumeFileName }}
                    </div>
                  </v-col>
                  <v-col cols="5" class="pt-1 pb-1">
                    <span
                      class="text-h5 font-weight-bold float-right"
                      :class="$colorUtils.overallScoreTextColor(r.OverallScore)"
                      v-if="
                        r.Status == 'done' &&
                        !r.NotResume &&
                        !r.InvalidJobPosting
                      "
                    >
                      {{ r.OverallScore }}%
                    </span>
                    <v-chip
                      color="blue"
                      class="white--text float-right"
                      small
                      label
                      v-if="r.Status == 'created'"
                    >
                      Processing...
                    </v-chip>
                    <v-chip
                      color="red"
                      class="white--text float-right"
                      small
                      label
                      v-if="r.NotResume"
                    >
                      Invalid resume
                    </v-chip>
                    <v-chip
                      color="red"
                      class="white--text float-right"
                      small
                      label
                      v-if="!r.NotResume && r.InvalidJobPosting"
                    >
                      Invalid url
                    </v-chip>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-col>

        <v-col cols="12" v-if="!loading && reviewsAI.length === 0">
          <v-alert type="info" outlined>
            You don't have any reviews yet.
          </v-alert>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" v-if="hasMore">
          <div class="d-flex mb-2 mt-5">
            <v-spacer></v-spacer>
            <v-btn plain @click="showMore" :loading="showMoreLoading">
              Show more
            </v-btn>
            <v-spacer></v-spacer>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      errorMsg: "",
      loading: true,
      showMoreLoading: false,
      cursorTs: "",
      hasMore: false,
      reviewsAI: [],
    };
  },
  beforeCreate() {
    this.$utils.visit(this);
  },
  mounted() {
    this.getReviewsForUser();
  },
  methods: {
    async getReviewsForUser() {
      if (this.reviewsAI.length == 0) {
        this.loading = true;
      }
      this.errorMsg = "";
      try {
        var resp = await this.$utils.callBackendPost(
          this,
          "/api/getReviewsForUserAI",
          {
            userEmail: "",
            pageSize: 5,
            cursorTs: this.cursorTs,
          }
        );
        // console.log(
        //   "getReviewsForUserAI got resp: " + JSON.stringify(resp, null, 2)
        // );

        this.cursorTs = resp.NextPage;
        this.hasMore = resp.HasMore;
        if (resp.ReviewsAI) {
          // filter out reviews with status "error"
          resp.ReviewsAI = resp.ReviewsAI.filter((r) => r.Status !== "error");
          this.reviewsAI.push(...resp.ReviewsAI);
          this.reviewsAIGroupedByDay = this.groupByDay(this.reviewsAI);
          console.log(
            "reviewsAIGroupedByDay: " +
              JSON.stringify(this.reviewsAIGroupedByDay, null, 2)
          );
        }
      } catch (error) {
        this.errorMsg = error;
      } finally {
        this.loading = false;
      }
    },
    groupByDay(reviews) {
      // grouping by day
      const reviewsGroupedByDay = reviews.reduce((acc, item) => {
        const date = new Date(item.UploadedTs);

        // Create a day key like "2025-11-10"
        const dayKey = date.toISOString().slice(0, 10);

        if (!acc[dayKey]) {
          acc[dayKey] = [];
        }

        acc[dayKey].push(item);
        return acc;
      }, {});

      return reviewsGroupedByDay;
    },
    async showMore() {
      this.showMoreLoading = true;
      await this.getReviewsForUser();
      this.showMoreLoading = false;
    },
  },
};
</script>

<style scoped>
.main-card {
  width: 100vw;
  max-width: 1200px;
}
.left-border-orange {
  border-left: 20px solid orange !important;
}
.left-border-blue {
  border-left: 20px solid blue !important;
}
.left-border-purple {
  border-left: 20px solid purple !important;
}
</style>
